// Import individual components to create structured exports
import { Confirm2fa } from './Confirm2fa';
import { LoginMain } from './LoginMain';
import { LoginTrouble } from './LoginTrouble';
import { SSOLogin, SSOLoginErrors } from './SSOLogin';
import { TwoFactorRecovery } from './TwoFactorRecovery';

export const Login = {
  main: LoginMain,
  trouble: LoginTrouble,
  mfa: Confirm2fa,
  twoFactorRecovery: TwoFactorRecovery,
  ssoLogin: SSOLogin,
  ssoLoginErrors: SSOLoginErrors,
};

export * from './Account';
export * from './ForgotPassword';
export * from './Registration';
